import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  changeEditableMessage,
  setEditableMessage,
  setIsDirty,
} from '../../../../../../redux/activ8/activ8MessagesReducer';
import CommonTextarea from '../../../../../../components/common-textarea/CommonTextarea';
import CommonButton from '../../../../../../components/common-button/CommonButton';

import scss from './MessageCard.module.scss';

function EditSection({ setMessageLocalText, message, messageLocalText, onSave }) {
  const { t } = useTranslation('activ8');
  const dispatch = useDispatch();

  const handleEditClose = () => {
    dispatch(setEditableMessage({ id: null, message: '' }));
    dispatch(setIsDirty(false));
    setMessageLocalText(message);
  };

  const handleChangeText = (newTextValue) => {
    setMessageLocalText(newTextValue);
    dispatch(changeEditableMessage(newTextValue));
  };

  const handleSaveTextChanges = () => {
    onSave({ newText: messageLocalText, oldText: message });
    handleEditClose();
  };

  return (
    <div className={scss.inputCell}>
      <CommonTextarea value={messageLocalText} onChange={handleChangeText} rows='3' />

      <div className={scss.inputCellActions}>
        <CommonButton styleColor='secondary' maxWidth={120} onClick={handleEditClose}>
          {t('discard')}
        </CommonButton>

        <CommonButton styleColor='primary' maxWidth={120} onClick={handleSaveTextChanges}>
          {t('saveChanges')}
        </CommonButton>
      </div>
    </div>
  );
}

export default EditSection;
